export const ABUSE_NOT_REPORTED = 0;
export const ABUSE_REPORTED = 1;
